import {
  FETCH_USER_SUBSCRIPTION_PLANS_START,
  FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS,
  FETCH_USER_SUBSCRIPTION_PLANS_FAILURE,
  CANCEL_USER_SUBSCRIPTION_PLAN_START,
  CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS,
  CANCEL_USER_SUBSCRIPTION_PLAN_FAILURE,
} from './actions';

import Resource, { ResourceApi } from '../../resource/Resource';
import { USER_SUBSCRIPTION_PLAN as USER_SUBSCRIPTION_PLAN_RESOURCE } from '../resourceNames';
import { currentUserIdSelector } from '../Auth/selectors';
import { selectCurrentUserSubscriptionPlansHasLoaded } from './selectors';
import { ROUTE_PAYMENT_UPDATE_PAYMENT_METHOD_PAGE } from '../routeActions';

export const fetchUserSubscriptionPlans = () => {
  return (dispatch, getState) => {
    const hasLoaded = selectCurrentUserSubscriptionPlansHasLoaded(getState());
    const userId = currentUserIdSelector(getState());

    if (hasLoaded || !userId) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_USER_SUBSCRIPTION_PLANS_START,
    });

    return new Promise((resolve, reject) => {
      Resource.lookup(
        USER_SUBSCRIPTION_PLAN_RESOURCE,
        'getUserSubscriptionPlans'
      ).then(
        (subscriptionPlans) => {
          dispatch({
            type: FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS,
            subscriptionPlans,
            userId,
          });
          resolve();
        },
        () => {
          dispatch({
            type: FETCH_USER_SUBSCRIPTION_PLANS_FAILURE,
          });
          reject(Error());
        }
      );
    });
  };
};

export const loadCurrentUserSubscriptionPlanData = (dispatch) => {
  return dispatch(fetchUserSubscriptionPlans());
};

export const cancelUserSubscriptionPlan = (userSubscriptionPlanId) => {
  return (dispatch) => {
    dispatch({
      type: CANCEL_USER_SUBSCRIPTION_PLAN_START,
      userSubscriptionPlanId,
    });

    return ResourceApi.update(
      USER_SUBSCRIPTION_PLAN_RESOURCE,
      userSubscriptionPlanId,
      'scheduleCancelSubscription'
    ).then(
      (userSubscriptionPlan) => {
        dispatch({
          type: CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS,
          userSubscriptionPlan,
        });
      },
      (error) => {
        dispatch({
          type: CANCEL_USER_SUBSCRIPTION_PLAN_FAILURE,
        });
        throw error;
      }
    );
  };
};

export const updatePaymentMethodClick = (userSubscriptionPlanId) => {
  return (dispatch) => {
    dispatch({
      type: ROUTE_PAYMENT_UPDATE_PAYMENT_METHOD_PAGE,
      query: {
        subscriptionId: userSubscriptionPlanId,
      },
    });
  };
};

export const fetchPaymentMethodSummary = (userSubscriptionPlanId) => {
  return () =>
    ResourceApi.read(
      USER_SUBSCRIPTION_PLAN_RESOURCE,
      userSubscriptionPlanId,
      'getPaymentMethodSummary'
    );
};
